import "react-toastify/dist/ReactToastify.css";

import "./index.css";

import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { Token } from "./Models/Authentication";
import { IvrState } from "./Models/IvrState";
import * as serviceWorker from "./serviceWorker";
import { LocalStorageConfigs, loadFromLocal } from "./Utils/LocalStorage";
import EnvironmentConfiguration from "./V2/Constants/EnvironmentConfiguration";

const container = document.getElementById("root");

// Create a root.
if (!container) throw "Root could not be found.";
const root = createRoot(container);

// Initial render
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// if the user is logged in and the environment is not local display confirmation alert on page close
window.addEventListener("beforeunload", ev => {
  if (loadFromLocal<Token>(LocalStorageConfigs.token.key) && process.env.REACT_APP_ENVNAME !== "Local") {
    ev.preventDefault();
    return (ev.returnValue = "ignored");
  }
});

// When closing the window if the user is logged in and available update ivr status to unavailable.
window.addEventListener("unload", () => {
  const token = loadFromLocal<Token>(LocalStorageConfigs.token.key);
  if (token && loadFromLocal<IvrState>(LocalStorageConfigs.ivrState.key)?.state === "Available")
    // Can't use useApi or axios here since no renders may occur between beforeunload being invoked and unloading.
    window.fetch(`${EnvironmentConfiguration.apiBaseUrl}/user/me/ivr/state`, {
      keepalive: true,
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token.token}` },
      body: JSON.stringify({ state: "Unavailable" } as IvrState)
    });
});
